import React, { useCallback, useState, useEffect, useRef, useMemo } from 'react';
import style from './MedicalReservationHistory.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from '../../../../constants/url';
import noDoctorImg from '../../../../images/user/i_3d_hospital_inform_link_01.svg';
import noDoctorImgPng from '../../../../images/user/i_3d_hospital_inform_link_01.png';
import { useLocation } from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import { formatDateWithWeekday, formatTime24 } from '../../../../assets/js/comm';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import Skeleton from '@mui/material/Skeleton';

const PAGE_SIZE = 10;

// 스켈레톤 컴포넌트
const SkeletonItem = () => (

    <div className={style['hospital-sch-wrap']} >
        <div className='inner-box'>
            <div className={style['top-box']}>
                <div className={style['head']}>
                    <div className={style['hospital-type']}>
                        <Skeleton variant="text" width={80} height={20} />
                    </div>
                    <div className={style['date-box']}>
                        <Skeleton variant="text" width={120} height={20} />
                    </div>
                </div>

                <div className={style['mid']}>
                    <ul>
                        <li>
                            <div className={style['avatar']}>
                                <div className={style['avatar-box']}>
                                    <Skeleton variant="circular" width={48} height={48} />
                                </div>
                                <div className={style['avatar-infom']}>
                                    <Skeleton variant="text" width={80} height={20} />
                                    <Skeleton variant="text" width={60} height={16} />
                                </div>
                            </div>
                            <div className={style['medical-inform']}>
                                <div className={style['medic-notice']}>
                                   <Skeleton variant="text" width={200} height={20} />
                                </div>
                                <div className={style['medic-list']} style={{width:'60px', height:'24px'}}></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    
);

const MedicalReservationHistory = () => {

    const navigate = useNavigate();

    const location = useLocation();
    const [mediInfo, setMediInfo] = useState();
    const [hsptlClnicRsvtList,  setHsptlClnicRsvtList] = useState([]);
    
    const { hsptlCd = "", hsptlNm = "", patntId = "" } = location.state || {};

    const isFirstRender = useRef(true);


    const observerRef = useRef(null);
    const scrollObserver = useRef(null);
    const [pageNo, setPageNo] = useState(1);
    const [hasNext, setHasNext] = useState(true);

    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // 상태 추가

    // 페이지 진입 시 스크롤 맨 위로
    useEffect(() => {
        window.scrollTo(0, 0);
        document.getElementById('sub-content')?.scrollTo(0, 0);
    }, []);


    // ✅ pageNo 변경 시 (2 이상) 호출
    useEffect(() => {
        console.log("========= 현재 페이지 : ", pageNo)
        if (pageNo > 1 && hasNext && !isLoadingMore) {
            if(value==1){
                getClnicInfo('N',pageNo);
            }else{
                getClnicInfo('X',pageNo);
            }
        }
    }, [pageNo]);


    // ✅ observer는 데이터가 렌더링된 이후에만 등록
    useEffect(() => {

        if (!hasNext || hsptlClnicRsvtList.length === 0 || isLoadingMore) return;

        // 기존 observer 제거
        if (scrollObserver.current && observerRef.current) {
            scrollObserver.current.unobserve(observerRef.current);
        }

        scrollObserver.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !isLoadingMore) {
                setPageNo(prev => prev + 1);
            }
        }, {
            root: null,
            rootMargin: '100px',
            threshold: 1.0
        });

        if (observerRef.current) {
            scrollObserver.current.observe(observerRef.current);
        }

        return () => {
            if (scrollObserver.current && observerRef.current) {
                scrollObserver.current.unobserve(observerRef.current);
            }
        };

    }, [hsptlClnicRsvtList.length, hasNext]);



    useEffect(()=>{

        if (isFirstRender.current) {
            isFirstRender.current = false;
            //getClnicInfo('N');
            return;
        }

    }, [])


    const getClnicInfo = useCallback(async (_stat='N', _pageNo=1) => {

        // 이미 로딩 중이면 중복 호출 방지
        if (_pageNo > 1 && isLoadingMore) return;

        // 첫 페이지 로딩 시작
        if (_pageNo === 1) {
            setIsLoading(true);
        } else {
            setIsLoadingMore(true);
        }

        const url = "/hsptl/retrieveHsptlClnicRsvt";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            hsptlCd : hsptlCd, 
            patntId : patntId,
            stat : _stat,
            pageNo : _pageNo,
            pageSize : PAGE_SIZE
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
            , noLoading: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            console.log(res.data.resultCode)
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                const mediInfo = res.data.result;
                
                setMediInfo({...mediInfo});
                //setHsptlClnicRsvtList(mediInfo.hsptlClnicRsvtList);

                setHsptlClnicRsvtList(prev => [...prev, ...mediInfo.hsptlClnicRsvtList]);
                //if (!res.data.result.hasNext) setHasNext(false);
                setHasNext(!!mediInfo.hasNext);   // ✅ true/false를 항상 최신으로 반영


            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })
        .finally(() => {
            if (_pageNo === 1) {
            setIsLoading(false);
            } else {
                setIsLoadingMore(false);  
            }
        });

    }, [navigate]);



    const [value, setValue] = React.useState('1');
    
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }; 
 
    useEffect(()=>{

        setPageNo(1);
        setHsptlClnicRsvtList([]);

        if(value==1){
            getClnicInfo('N',1);
        }else{
            getClnicInfo('X',1);
        }

    }, [value])

 
    function getAppointmentMessage(targetDateStr) {
        // 오늘 날짜 자동 생성 (YYYYMMDD)
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayDateStr = `${yyyy}${mm}${dd}`;
      
        // 문자열을 날짜 객체로 변환 (YYYYMMDD)
        const toDate = (str) => {
          const year = parseInt(str.slice(0, 4), 10);
          const month = parseInt(str.slice(4, 6), 10) - 1;
          const day = parseInt(str.slice(6, 8), 10);
          return new Date(year, month, day);
        };
      
        const targetDate = toDate(targetDateStr);
        const todayDate = toDate(todayDateStr);
      
        const msPerDay = 1000 * 60 * 60 * 24;
        const diffDays = Math.floor((targetDate - todayDate) / msPerDay);
      
        if (diffDays === 0) {
          return "<p>오늘은 <b>진료당일</b> 입니다.</p>";
        } else if (diffDays > 0) {
          return `${diffDays}`;
        } else {
          return "이미 진료일이 지났습니다.";
        }
    }

    const isToday = (dateStr) => {
        // 오늘 날짜를 YYYYMMDD 형태로 만들기
        const today = new Date();
        const yyyy = today.getFullYear().toString();
        const mm = (today.getMonth() + 1).toString().padStart(2, '0');
        const dd = today.getDate().toString().padStart(2, '0');
        const todayStr = yyyy + mm + dd;
        return dateStr === todayStr;
    }

    const groupedClnicRsvtList = useMemo(() => {
        if (!Array.isArray(hsptlClnicRsvtList)) return [];
        const map = {};
        hsptlClnicRsvtList.forEach((item) => {
            const key = item.hsptlCd + "_" + item.resvDt + "_" + item.deptCd + "_" + item.doctrCd;
            if (!map[key]) {
                map[key] = {
                    ...item,
                    items: [],
                    totalClnicCnt: 0,
                    totalClnicExmnCnt: 0,
                };
            }
            map[key].items.push(item);
            map[key].totalClnicCnt += (item.clnicCnt || 0);
            map[key].totalClnicExmnCnt += (item.clnicExmnCnt || 0);
        });
        return Object.values(map);
    }, [hsptlClnicRsvtList]);

    return (
        <>
            <HeadSub title="진료 예약 내역" hospitalName={hsptlNm+"병원"} />
            
            <div id="sub-content" data-type="d">
                <div className='inner-wrap' data-pad="normal">

                    <div className={style['top-fix-bar']}>
                        <TabContext value={value}>
                                <div className="top-tab-head" data-type="b">
                                    <TabList
                                        onChange={handleChange}
                                        aria-label="lab API tabs example"
                                        variant="scrollable"
                                        scrollButtons={false}
                                        className={style['tab-lists']}
                                    >
                                        <Tab label="진료 예정" value="1" disableRipple />
                                        <Tab label="진료 취소" value="2" disableRipple />
                                    </TabList>
                                </div>



                                <TabPanel value="1">

                                    <div className={style['tab-content']}>
                                         
                                            {/* 진료 예약 */}

                                            {(() => {

                                                const filteredList = groupedClnicRsvtList.filter(g => g.stat !== 'X');

                                                // 로딩 중일 때 스켈레톤 표시
                                                if (isLoading) {
                                                    return (
                                                        <div className={style['history-list-box']}>
                                                            <ul>
                                                                {[...Array(5)].map((_, index) => (
                                                                    <SkeletonItem key={index} />
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    );
                                                }


                                                if (filteredList.length === 0) {
                                                    return (
                                                        <div className={style['no-data-box']}>
                                                            <span>내역이 없습니다.</span>
                                                        </div>

                                                    );
                                                }
                                            })()}

                                            {groupedClnicRsvtList.filter(g => g.stat !== 'X').map((group, item1Index) => {
                                                    return(
                                                        <div key={group.hsptlCd + "_" + group.resvDt + "_" + group.deptCd + "_" + group.doctrCd} className={style['hospital-sch-wrap']} onClick={()=> navigate(URL.HOSPITAL_MEDICALRESERVATIONDETAILSIN, {
                                                            state: {
                                                                hsptlCd: group.hsptlCd,
                                                                hsptlNm: hsptlNm,
                                                                deptCd: group.deptCd,
                                                                doctrCd: group.doctrCd,
                                                                patntId: group.patntId,
                                                                resvDt: group.resvDt,
                                                                resvTm: group.resvTm
                                                            }
                                                        })}>
                                                            <div className='inner-box'>
                                                                <div className={style['top-box']}>
                                                                    <div className={style['head']}>
                                                                        <div className={style['hospital-type']}>
                                                                        <p className={style['h-in']}>외래 진료</p>
                                                                        {/* <p className={style['h-out']}>비대면 진료</p>  */}
                                                                        </div>
                                                                        <div className={style['date-box']}>
                                                                            <strong>{formatDateWithWeekday(group.resvDt)}</strong>
                                                                            <p>{formatTime24(group.resvTm)}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className={style['mid']}>
                                                                        <ul>
                                                                            <li>
                                                                                <div className={style['avatar']}>
                                                                                    {/* <Avatar
                                                                                        alt={group.doctrNm+" 교수님"}
                                                                                        src={group.doctrImgUrl}
                                                                                        sx={{ width: 48, height: 48 }}
                                                                                    /> */}
                                                                                    <div className={style['avatar-box']}>
                                                                                        {!group.doctrImgUrl ? (
                                                                                            <object data={noDoctorImg} className={style['sampleD']} aria-hidden='true'></object>
                                                                                        ) : (
                                                                                            <img
                                                                                            src={group.doctrImgUrl}
                                                                                            alt={group.doctrNm+" 교수님"}
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = noDoctorImgPng;
                                                                                            }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                    <div className={style['avatar-infom']}>
                                                                                        <p>{group.deptNm}</p>
                                                                                        <span>{group.doctrNm} 교수님</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className={style['medical-inform']}>
                                                                                    <div className={style['medic-notice']}>
                                                                                        {
                                                                                            (() => {
                                                                                                if (isToday(group.resvDt)) {
                                                                                                    return <><p>오늘은 <b>진료당일</b> 입니다.</p></>;
                                                                                                } else {
                                                                                                    return <><p>진료 예정일까지 <b>{getAppointmentMessage(group.resvDt)}일</b> 남았습니다.</p></>;
                                                                                                }
                                                                                            })()
                                                                                        }
                                                                                    </div>
                                                                                    <div className={style['medic-list']}>
                                                                                        <p>진료 <b>{group.totalClnicCnt}</b></p>
                                                                                        <p>검사 <b>{group.totalClnicExmnCnt}</b></p>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                            })}
                                    </div>   
                                </TabPanel>


                                <TabPanel value="2">

                                    <div className={style['tab-content']}>
                                            
                                            {/* 진료 취소 */}

                                            {(() => {
                                                const filteredList = groupedClnicRsvtList.filter(g => g.stat === 'X');

                                                // 로딩 중일 때 스켈레톤 표시
                                                // if (isLoading) {
                                                //     return (
                                                //         <div className={style['history-list-box']}>
                                                //             <ul>
                                                //                 {[...Array(5)].map((_, index) => (
                                                //                     <SkeletonItem key={index} />
                                                //                 ))}
                                                //             </ul>
                                                //         </div>
                                                //     );
                                                // }


                                                if (filteredList.length === 0) {
                                                    return (
                                                        <div className={style['no-data-box']}>
                                                            <span>내역이 없습니다.</span>
                                                        </div>

                                                    );
                                                }
                                            })()}


                                            {
                                                groupedClnicRsvtList.filter(g => g.stat === 'X').map((group, item1Index) => {
                                                    return(
                                                        <div key={group.hsptlCd + "_" + group.resvDt + "_" + group.deptCd + "_" + group.doctrCd} className={style['hospital-sch-wrap']} onClick={()=> navigate(URL.HOSPITAL_MEDICALRESERVATIONDETAILSIN, {
                                                            state: {
                                                                hsptlCd: group.hsptlCd,
                                                                hsptlNm: hsptlNm,
                                                                deptCd: group.deptCd,
                                                                doctrCd: group.doctrCd,
                                                                patntId: group.patntId,
                                                                resvDt: group.resvDt,
                                                                resvTm: group.resvTm
                                                            }
                                                        })}>
                                                            <div className='inner-box'>
                                                                <div className={style['top-box']}>
                                                                    <div className={style['head']}>
                                                                        <div className={style['hospital-type']}>
                                                                        <p className={style['h-in']}>외래 진료</p>
                                                                        {/* <p className={style['h-out']}>비대면 진료</p>  */}
                                                                        </div>
                                                                        <div className={style['date-box']}>
                                                                            <strong>{formatDateWithWeekday(group.resvDt)}</strong>
                                                                            <p>{formatTime24(group.resvTm)}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className={style['mid']}>
                                                                        <ul>
                                                                            <li>
                                                                                <div className={style['avatar']}>
                                                                                    {/* <Avatar
                                                                                        alt={group.doctrNm+" 교수님"}
                                                                                        src={group.doctrImgUrl}
                                                                                        sx={{ width: 48, height: 48 }}
                                                                                    /> */}
                                                                                    <div className={style['avatar-box']}>
                                                                                        {!group.doctrImgUrl ? (
                                                                                            <object data={noDoctorImg} className={style['sampleD']} aria-hidden='true'></object>
                                                                                        ) : (
                                                                                            <img
                                                                                            src={group.doctrImgUrl}
                                                                                            alt={group.doctrNm+" 교수님"}
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = noDoctorImgPng;
                                                                                            }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                    <div className={style['avatar-infom']}>
                                                                                        <p>{group.deptNm}</p>
                                                                                        <span>{group.doctrNm} 교수님</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className={style['medical-inform']}>
                                                                                    <div className={style['medic-notice']}>
                                                                                        <p>진료가 <b>취소</b> 되었습니다.</p>
                                                                                    </div>
                                                                                    <div className={style['medic-list']}>
                                                                                        <p>진료 <b>{group.totalClnicCnt}</b></p>
                                                                                        <p>검사 <b>{group.totalClnicExmnCnt}</b></p>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                            })}
                                    </div>   
                                </TabPanel>

                        </TabContext>
                        
                    </div>

                </div>
            </div>

            {/* 더 로딩 중일 때 표시 */}
            {isLoadingMore && (
                <div className={style['history-list-box']}>
                    <ul>
                        <SkeletonItem />
                    </ul>
                </div>
            )}
            
            {/* Observer 타겟 */}
            {hasNext && <div ref={observerRef} style={{ height: '1px' }} />}

        </>
    );
};

export default MedicalReservationHistory; 
